import './assets/fonts.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// ✅ Initialize Firebase before anything else uses it
import './firebase'

const app = createApp(App)

app.use(router)
app.mount('#app')